module.exports = __webpack_public_path__ + "static/media/8.Juicer Machine.b1852d60.jpg";